import TaxRoundingConfigFields from "./TaxRoundingConfigFields";
import React, {useState} from "react";

const AddTaxRoundingConfig = () => {

    const [name, setName] = useState("");

    const [crumbs] = useState([
            {content: "Home", url: "/home"},
            {content: "Tax Rounding Configs", url: "/tax-rounding-config"},
            {content: "Add Tax Rounding Config", url: ""}
        ]
    )

    return (
        <>
            <TaxRoundingConfigFields crumbs={crumbs} title={"Add Tax Rounding Config"} btnText={"Create"}/>
        
        </>
    )
}

export default AddTaxRoundingConfig;